import { Shadows } from '@mui/material/styles'

const customShadows: Shadows = [
  'none',
  '0px 1px 2px rgba(0, 0, 0, 0.25)',
  '0px 1px 3px rgba(0, 0, 0, 0.25)',
  '0px 1px 4px rgba(0, 0, 0, 0.25)',
  '0px 2px 6px rgba(0, 0, 0, 0.25)',
  '0px 2px 8px rgba(0, 0, 0, 0.25)',
  '0px 3px 10px rgba(0, 0, 0, 0.25)',
  '0px 4px 12px rgba(0, 0, 0, 0.25)',
  '0px 5px 14px rgba(0, 0, 0, 0.25)',
  '0px 6px 16px rgba(0, 0, 0, 0.25)',
  '0px 7px 18px rgba(0, 0, 0, 0.25)',
  '0px 8px 20px rgba(0, 0, 0, 0.25)',
  '0px 9px 22px rgba(0, 0, 0, 0.25)',
  '0px 10px 24px rgba(0, 0, 0, 0.25)',
  '0px 11px 26px rgba(0, 0, 0, 0.25)',
  '0px 12px 28px rgba(0, 0, 0, 0.25)',
  '0px 13px 30px rgba(0, 0, 0, 0.25)',
  '0px 14px 32px rgba(0, 0, 0, 0.25)',
  '0px 15px 34px rgba(0, 0, 0, 0.25)',
  '0px 16px 36px rgba(0, 0, 0, 0.25)',
  '0px 17px 38px rgba(0, 0, 0, 0.25)',
  '0px 18px 40px rgba(0, 0, 0, 0.25)',
  '0px 19px 42px rgba(0, 0, 0, 0.25)',
  '0px 20px 44px rgba(0, 0, 0, 0.25)',
  '0px 21px 46px rgba(0, 0, 0, 0.25)',
]

export default customShadows
